import React from "react"
import styled from "styled-components"
import List from "./list"

const DevelopmentStage = () => {
  return (
    <>
    <Wrapper>
      <h2>Development Stage</h2>
      <p>
      We are in the business of creating stunning stores for our customers through Shopify custom designs. This means that as our client, you are able to edit text, images, etc. to make your store as unique and individualized as possible. Our company can take you from an idea to a fully functional product with efficiency and ease. We utilize only the latest technology to assure that your store is as responsive and functional as possible. At Shopify Systems, our agents are leaders in development and can take your business to the next level.
      </p>
    </Wrapper>
    <List />
    </>
  )
}

const Wrapper = styled.section`
  margin-top: 100px;
  margin-bottom: 20px;
  padding: 26px 20px;
  h2 { font-size: 30px; line-height: 47px; } 
  p { font-size: 12px; line-height: 190%; }
  @media screen and (min-width: 360px) { padding: 25px 57px; }
  @media screen and (min-width: 768px) { padding: 25px 77px; }
  @media screen and (min-width: 1024px) { margin: 100px 129px; }
  @media screen and (min-width: 1025px) { 
    padding: 0;
    width: 90vw;
    margin: 150px auto;
    max-width: 1170px;
    h2 { font-size: 46px; line-height: 72px; }
    p { width: 582px; font-size: 14px; line-height: 190%; text-align: justify; }
  }
  @media (min-width: 1180px) {width: 100%;}
`

export default DevelopmentStage
